angular.module('mercury.modules.stock.tender')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Stock.TenderList', {
    url: '/tenders',
    templateUrl: 'modules/stock/tender/list.tpl.html',
    controller: 'StockTenderListCtrl'
  });

  $stateProvider.state('Stock.TenderEdit', {
    url: '/tenders/edit/:id',
    templateUrl: 'modules/stock/tender/edit.tpl.html',
    controller: 'StockTenderEditCtrl',
    data: {
      menuLinkState: 'Stock.TenderList'
    }
  });

  $stateProvider.state('Stock.TenderCreate', {
    url: '/tenders/create',
    templateUrl: 'modules/stock/tender/edit.tpl.html',
    controller: 'StockTenderEditCtrl',
    data: {
      menuLinkState: 'Stock.TenderList'
    }
  });

  $stateProvider.state('Stock.TenderReview', {
    url: '/tenders/review/:id?:start&:end&:credits',
    templateUrl: 'modules/stock/tender/review.tpl.html',
    controller: 'StockTenderReviewCtrl',
    data: {
      menuLinkState: 'Stock.TenderList'
    }
  });
}]);
